import { useTranslation } from 'next-i18next';
import { useCallback, useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  SearchContext,
  SearchContextInterface
} from '../../../search-new/context/SearchContext';
import { useSelector } from 'react-redux';

interface SaleTypeProps {
  saleTypes: {
    name: 'all' | 'developer_sale' | 'resale' | 'nawy_now';
    value: 'all' | 'developer_sale' | 'resale' | 'nawy_now';
  }[];
  handleTabChange: (
    saleType: 'all' | 'developer_sale' | 'resale' | 'nawy_now'
  ) => void;
}

const SaleTypeTabs = ({ saleTypes, handleTabChange }: SaleTypeProps) => {
  const { t } = useTranslation();

  const { searchFiltersState } = useContext(
    SearchContext
  ) as SearchContextInterface;

  const isMobile = useSelector((state: any) => state.app.isMobile);

  const isTabSelected = useCallback(
    (saleType: 'all' | 'developer_sale' | 'resale' | 'nawy_now') => {
      const saleTypeFilters = searchFiltersState.searchFilters.sale_type;
      const onNawyNowTab = searchFiltersState.searchFilters.nawy_now;

      if (onNawyNowTab && saleType === 'nawy_now') {
        localStorage.setItem('nawyNowTabClicked', 'true');
        return true;
      }

      if (saleType === 'all' && !onNawyNowTab) {
        return (
          saleTypeFilters.length === 0 ||
          (saleTypeFilters.includes('developer_sale') &&
            saleTypeFilters.includes('resale') &&
            saleTypeFilters.length === 2)
        );
      } else {
        return (
          saleTypeFilters.includes(saleType) && saleTypeFilters.length === 1
        );
      }
    },
    [searchFiltersState.searchFilters.sale_type]
  );

  const [wasClicked, setWasClicked] = useState(false);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setWasClicked(localStorage.getItem('nawyNowTabClicked') === 'true');
    }
  }, []);

  return (
    <Container id="sale-type-tabs">
      {saleTypes.map(saleType => {
        return (
          <SaleTab
            key={saleType.name}
            className={`sale-type-tab ${
              isTabSelected(saleType.value) ? 'active' : ''
            }`}
            onClick={() => handleTabChange(saleType.value)}
          >
            {saleType.name === 'nawy_now' && !wasClicked && (
              <div className="tab-alert" />
            )}
            {isMobile && saleType.name === 'developer_sale' ? (
              <>{t('developer', { ns: 'common' })}</>
            ) : (
              <>{t(saleType.name, { ns: 'common' })}</>
            )}
          </SaleTab>
        );
      })}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

const SaleTab = styled.button`
  padding: 8px 0;
  width: calc(100% / 4);
  border: none;
  outline: none;
  background-color: transparent;
  border-bottom: 1px solid #d3dbe6;
  cursor: pointer;
  font-size: 17px;
  color: #697586;
  line-height: 150%;
  font-family: materialMedium;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  &.active {
    border-bottom: 1px solid #015c9a;
    color: #015c9a;
    font-family: materialMedium;
  }

  .tab-alert {
    width: 9px;
    height: 9px;
    background-color: #ff5e00;
    border-radius: 50%;
    margin-bottom: 2px;
  }

  @media screen and (max-width: 768px) {
    font-size: 12px;
    color: #7f7f7f;
    &.active {
      font-family: materialRegular;
    }
  }
`;

export default SaleTypeTabs;
